module.exports = __webpack_public_path__ + "d94e20c1/img/scraper-icon.df6ccde5.svg";